// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  width: 508px;
  height: 539px;
  position: relative;
}
@media (min-width: 1620px) {
  form {
    width: 559px;
    height: 593px;
  }
}
@media (max-width: 1050px) {
  form {
    width: 413px;
    height: 593px;
  }
}
@media (max-width: 550px) {
  form {
    width: 100%;
    height: 551px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
}
form .form-title {
  width: 100%;
  display: block;
  margin-bottom: 64px;
  text-transform: uppercase;
  color: #575756;
  font-family: FixelDisplay;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  form .form-title {
    font-family: FixelDisplay;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 550px) {
  form .form-title {
    text-align: center;
    width: 193px;
    margin-bottom: 48px;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
form .input-field {
  width: 100%;
  padding-bottom: 25px;
  position: relative;
}
form .input-field.textarea .input-item {
  height: 96px;
  padding-top: 24px;
  resize: none;
}
@media (max-width: 550px) {
  form .input-field.textarea .input-item {
    height: 100px;
    padding-top: 20px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
form .input-field .input-item {
  width: calc(100% - 52px);
  height: 64px;
  padding: 0 24px;
  background-color: #FFFFFF;
  color: #575756;
  border-radius: 12px;
  border: 2px solid #EAEAEA;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  form .input-field .input-item {
    height: 70px;
    font-family: FixelDisplay;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  form .input-field .input-item {
    height: 56px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
form .input-field .input-item.error {
  border: 2px solid #AE2323;
}
form .input-field .input-item.error::placeholder {
  color: #AE2323;
}
form .input-field .input-item.error:focus::placeholder {
  color: #AE2323;
}
form .input-field .input-item.error:focus {
  outline: none;
  border: 2px solid #AE2323;
}
form .input-field .input-item::placeholder {
  color: #575756;
  font-family: FixelDisplay;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  form .input-field .input-item::placeholder {
    font-family: FixelDisplay;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
form .input-field .input-item:focus::placeholder {
  color: #BCBCBC;
}
form .input-field .input-item:focus {
  outline: none;
  border: 2px solid #EAEAEA;
}
form .input-field .err-txt {
  position: absolute;
  color: #AE2323;
  bottom: 8px;
  left: 0;
  opacity: 0;
  text-transform: uppercase;
  transition: opacity 0.4s ease-in-out;
  font-family: FixelDisplay;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
form .input-field .err-txt.error {
  opacity: 1;
}
form .input-field .err-icon {
  position: absolute;
  top: 34px;
  right: 24px;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
@media (max-width: 550px) {
  form .input-field .err-icon {
    top: 30px;
  }
}
form .input-field .err-icon.error {
  opacity: 1;
}
form .form-add-text {
  width: 196px;
  position: absolute;
  bottom: 0;
  left: 0;
  color: #BCBCBC;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  form .form-add-text {
    width: 229px;
    font-family: FixelDisplay;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  form .form-add-text {
    bottom: 72px;
    width: 265px;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
form .form-button-container {
  position: absolute;
  bottom: 0;
  right: 0;
}
@media (max-width: 550px) {
  form .form-button-container {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FormSection/Form/Form.scss","webpack://./src/styles/mixins.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAIA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AAHJ;AAKI;EALJ;IAMQ,YAAA;IACA,aAAA;EAFN;AACF;AAII;EAVJ;IAWQ,YAAA;IACA,aAAA;EADN;AACF;AAGI;EAfJ;IAgBQ,WAAA;IACA,aAAA;ICpBJ,aAAA;IACA,sBDoByB;ICnBzB,2BDmBiC;IClBjC,mBDkB6C;EAG/C;AACF;AADI;EACI,WAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,cEtBI;EDAR,yBDuByB;ECtBzB,eDsBuC;ECrBvC,kBDqB6C;ECpB7C,gBDoBqD;ECnBrD,iBDmB0D;AAO9D;AALQ;EARJ;ICjBA,yBD0B6B;ICzB7B,eDyB2C;ICxB3C,kBDwBiD;ICvBjD,gBDuByD;ICtBzD,iBDsB8D;EAYhE;AACF;AAVQ;EAZJ;IAaQ,kBAAA;IACA,YAAA;IACA,mBAAA;IChCR,yBDiC6B;IChC7B,eDgC2C;IC/B3C,kBD+BiD;IC9BjD,gBD8ByD;IC7BzD,iBD6B8D;EAiBhE;AACF;AAdI;EACI,WAAA;EACA,oBAAA;EACA,kBAAA;AAgBR;AAbY;EACI,YAAA;EACA,iBAAA;EACA,YAAA;AAehB;AAbgB;EALJ;IAMQ,aAAA;IACA,iBAAA;IClDhB,yBDmDqC;IClDrC,eDkDmD;ICjDnD,kBDiDyD;IChDzD,gBDgDiE;IC/CjE,iBD+CsE;EAoBxE;AACF;AAhBQ;EACI,wBAAA;EACA,YAAA;EACA,eAAA;EACA,yBEjEJ;EFkEI,cE7DA;EF8DA,mBAAA;EACA,yBAAA;EACA,yBAAA;EChER,yBDiE6B;EChE7B,eDgE2C;EC/D3C,kBD+DiD;EC9DjD,gBD8DyD;EC7DzD,iBD6D8D;AAsBlE;AApBY;EAXJ;IAYQ,YAAA;ICpEZ,yBDqEiC;ICpEjC,eDoE+C;ICnE/C,kBDmEqD;IClErD,gBDkE6D;ICjE7D,iBDiEkE;EA2BpE;AACF;AAzBY;EAhBJ;IAiBQ,YAAA;ICzEZ,yBD0EiC;ICzEjC,eDyE+C;ICxE/C,kBDwEqD;ICvErD,gBDuE6D;ICtE7D,iBDsEkE;EAgCpE;AACF;AA9BY;EACI,yBAAA;AAgChB;AA9BgB;EACI,cE9Ed;AF8GN;AA7BgB;EACI,cElFd;AFiHN;AA5BgB;EACI,aAAA;EACA,yBAAA;AA8BpB;AA1BY;EACI,cE/FJ;EDAR,yBDgGiC;EC/FjC,eD+F+C;EC9F/C,kBD8FqD;EC7FrD,gBD6F6D;EC5F7D,iBD4FkE;AAgCtE;AA9BgB;EAJJ;IC9FR,yBDmGqC;IClGrC,eDkGmD;ICjGnD,kBDiGyD;IChGzD,gBDgGiE;IC/FjE,iBD+FsE;EAqCxE;AACF;AAlCY;EACI,cEvGJ;AF2IZ;AAjCY;EACI,aAAA;EACA,yBAAA;AAmChB;AA/BQ;EACI,kBAAA;EACA,cEhHN;EFiHM,WAAA;EACA,OAAA;EACA,UAAA;EACA,yBAAA;EACA,oCAAA;ECxHR,yBDyH6B;ECxH7B,eDwH2C;ECvH3C,kBDuHiD;ECtHjD,gBDsHyD;ECrHzD,iBDqH8D;AAqClE;AAnCY;EACI,UAAA;AAqChB;AAjCQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,oCAAA;AAmCZ;AAjCY;EARJ;IASQ,SAAA;EAoCd;AACF;AAlCY;EACI,UAAA;AAoChB;AA/BI;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,cEtJI;EFuJJ,yBAAA;ECxJJ,yBDyJyB;ECxJzB,eDwJuC;ECvJvC,kBDuJ6C;ECtJ7C,gBDsJqD;ECrJrD,iBDqJ0D;AAqC9D;AAnCQ;EATJ;IAUQ,YAAA;IC5JR,yBD6J6B;IC5J7B,eD4J2C;IC3J3C,kBD2JiD;IC1JjD,gBD0JyD;ICzJzD,iBDyJ8D;EA0ChE;AACF;AAxCQ;EAdJ;IAeQ,YAAA;IACA,YAAA;IClKR,yBDmK6B;IClK7B,eDkK2C;ICjK3C,kBDiKiD;IChKjD,gBDgKyD;IC/JzD,iBD+J8D;EA+ChE;AACF;AA5CI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AA8CR;AA5CQ;EALJ;IAMQ,WAAA;EA+CV;AACF","sourcesContent":["@use '../../../styles/mixins.scss';\n@import '../../../styles/variables.scss';\n\n\nform {\n    width: 508px;\n    height: 539px;\n    position: relative;\n\n    @media (min-width: 1620px) {\n        width: 559px;\n        height: 593px;\n    }\n\n    @media (max-width: 1050px) {\n        width: 413px;\n        height: 593px;\n    }\n\n    @media (max-width: 550px) {\n        width: 100%;\n        height: 551px;\n        @include mixins.flex(column, flex-start, center);\n    }\n\n    .form-title {\n        width: 100%;\n        display: block;\n        margin-bottom: 64px;\n        text-transform: uppercase;\n        color: $grey-dark;\n        @include mixins.font(FixelDisplay, 24px, normal, 500, 100%);\n\n        @media (min-width: 1620px) {\n            @include mixins.font(FixelDisplay, 32px, normal, 500, 100%);\n        }\n\n        @media (max-width: 550px) {\n            text-align: center;\n            width: 193px;\n            margin-bottom: 48px;\n            @include mixins.font(FixelDisplay, 14px, normal, 500, 130%);\n        }\n    }\n\n    .input-field {\n        width: 100%;\n        padding-bottom: 25px;\n        position: relative;\n\n        &.textarea {\n            .input-item {\n                height: 96px;\n                padding-top: 24px;\n                resize: none;\n\n                @media (max-width: 550px) {\n                    height: 100px;\n                    padding-top: 20px;\n                    @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n                }\n            }\n        }\n\n        .input-item {\n            width: calc(100% - 52px);\n            height: 64px;\n            padding: 0 24px;\n            background-color: $white;\n            color: $grey-dark;\n            border-radius: 12px;\n            border: 2px solid $grey;\n            text-transform: uppercase;\n            @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n\n            @media (min-width: 1620px) {\n                height: 70px;\n                @include mixins.font(FixelDisplay, 20px, normal, 500, 110%);\n            }\n\n            @media (max-width: 550px) {\n                height: 56px;\n                @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n            }\n\n            &.error {\n                border: 2px solid $red;\n\n                &::placeholder {\n                    color: $red;\n                }\n\n                &:focus::placeholder {\n                    color: $red;\n                }\n    \n                &:focus {\n                    outline: none;\n                    border: 2px solid $red;\n                }\n            }\n\n            &::placeholder {\n                color: $grey-dark;\n                @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n\n                @media (min-width: 1620px) {\n                    @include mixins.font(FixelDisplay, 20px, normal, 500, 110%);\n                }\n            }\n\n            &:focus::placeholder {\n                color: $grey-text;\n            }\n\n            &:focus {\n                outline: none;\n                border: 2px solid $grey;\n            }\n        }\n\n        .err-txt {\n            position: absolute;\n            color: $red;\n            bottom: 8px;\n            left: 0;\n            opacity: 0;\n            text-transform: uppercase;\n            transition: opacity 0.4s ease-in-out;\n            @include mixins.font(FixelDisplay, 12px, normal, 500, 110%);\n\n            &.error {\n                opacity: 1;\n            }\n        }\n\n        .err-icon {\n            position: absolute;\n            top: 34px;\n            right: 24px;\n            transform: translateY(-50%);\n            opacity: 0;\n            transition: opacity 0.4s ease-in-out;\n\n            @media (max-width: 550px) {\n                top: 30px;\n            }\n\n            &.error {\n                opacity: 1;\n            }\n        }\n    }\n\n    .form-add-text {\n        width: 196px;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        color: $grey-text;\n        text-transform: uppercase;\n        @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n\n        @media (min-width: 1620px) {\n            width: 229px;\n            @include mixins.font(FixelDisplay, 20px, normal, 500, 110%);\n        }\n\n        @media (max-width: 550px) {\n            bottom: 72px;\n            width: 265px;\n            @include mixins.font(FixelDisplay, 14px, normal, 500, 130%);\n        }\n    }\n\n    .form-button-container {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n\n        @media (max-width: 550px) {\n            width: 100%;\n        }\n    }\n}","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
